import makeStyles from '@mui/styles/makeStyles'

type Props = { isSingleMonth?: boolean }

export const useDateRangeStyles = makeStyles(theme => ({
  emptyRange: {
    '& .rdrSelected, & .rdrInRange, & .rdrStartEdge, & .rdrEndEdge': {
      background: '#fff',
    },
    '& .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span, & .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span, & .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span, & .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span': {
      color: 'black',
      '&:after': {
        background: theme.palette.primary.main,
      },
    },
  },
  dateRange: (props: Props) => ({
    '& .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span, & .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span, & .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span, & .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span': {
      color: 'black',
    },
    '& .rdrDayToday .rdrDayNumber span:after': {
      background: theme.palette.primary.main,
    },
    '& .rdrMonthName': {
      display: props.isSingleMonth ? 'none' : undefined,
    },
  }),
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
    margin: '18px 24px 12px 24px',
  },
  predefinedValuesContainer: {
    margin: '0 6px',
    borderBottom: '1px solid #f0f3f5',
  },
  formGroup: {
    maxWidth: 'fit-content',
    margin: '0 14px 12px 14px',
  },
  monthAndYearWrapper: (props: Props) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: props.isSingleMonth ? 'center' : 'space-between',
    alignItems: 'center',
    margin: '0 12px',
  }),
  monthAndYearDivider: {
    display: 'inline-block',
    width: 12,
  },
  prevNextButton: {
    color: theme.palette.action.active,
  },
}))
